import { BrowserView, isDesktop, isTablet, TabletView } from "react-device-detect"

export const isDesktopLike = isDesktop || isTablet

export function DesktopLikeView({ children }) {
	return (
		<>
			<BrowserView>{children}</BrowserView>
			<TabletView>{children}</TabletView>
		</>
	)
}

export default DesktopLikeView
